<template>
  <v-card-actions v-if="true">
      <v-flex>
        <selection-btn :value="value.active" @input="activateItem(value)">Ativo</selection-btn>
      </v-flex>
      <v-flex>            
              <v-text-field
              :value="value.seq"
              label="Sequencia"
              disabled
            ></v-text-field>               
       </v-flex>  
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <span>Editar</span>
        <v-btn icon flat color="grey lighten-1" slot="activator" @click.native.stop="itemEscolha(value.id)">
          <v-icon>create</v-icon>
        </v-btn>
      </v-tooltip>
      <v-tooltip bottom>
        <span>Excluir</span>
        <v-btn flat icon color="grey lighten-1" slot="activator" @click.native.stop="dialogExclude">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-tooltip>
       <v-tooltip bottom>
        <span>Divulgar</span>
        <v-btn icon flat color="grey lighten-1" slot="activator" @click.native.stop="newSchedule(value.id)">
          <v-icon>domain</v-icon>
        </v-btn>
      </v-tooltip>
      <!-- <v-tooltip bottom>
        <span>Estatísticas</span>
        <v-btn icon slot="activator">
          <v-icon>poll</v-icon>
        </v-btn>
      </v-tooltip> -->
      <v-dialog v-model="exclude" persistent max-width="290" v-if="exclude">
      <v-card>
        <v-card-title class="headline">Excluir item</v-card-title>
        <v-card-text>Deseja realmente excluir este item?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-1" flat @click.native="exclude = false">Não</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-1" flat @click.native="excludeItem">Sim</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-actions>
</template>


<script>
import selectionBtn from '@/components/SelectionBtn'
export default {
  name: 'item-actions',
  props: ['value'],
  data () {
    return {
      exclude: false
    }
  },
  components: {
    'selection-btn': selectionBtn
  },
  methods: {
    dialogExclude () {
      this.exclude = true
    },
    excludeItem () {
      // http://localhost:58515/api/v1/Itens/Remove?id=
      this.exclude = false
      this.$store.dispatch('deleteItem', this.value.id)
    },
    newSchedule () {
      this.$store.dispatch('newScheduleSelectedItem', this.value)
    },
    itemEscolha (item) {
      this.$store.dispatch('selectItem', item)
    },
    activateItem (value) {
      if (confirm('Tem certeza que deseja ' + (value.active ? 'inativar' : 'ativar') + ' o item?')) {
        this.$store.dispatch('changeActivation', value)
      }
    }
  }
}
</script>
<style>
.item-icon i{
  color: #bdbdbd!important;
}
.green-hover:hover i{
  color: #66bb6a!important;
}
</style>



// WEBPACK FOOTER //
// Actions.vue?16b0a1c0